export default __webpack_public_path__ + "static/media/nTrans.30984c8a.svg";